import { useState } from 'react'
import { Switch } from '@headlessui/react'
import { useDataToggleStore } from 'store'
import WORDING from 'constants/wording'
import { setToggleCard } from 'api/credit-card'
import handleNotification from 'utils/toast/handleNotification'

const { PAUSAR_TARJETA } = WORDING

const PauseToggle = ({ card, loadingStatus, getCard }) => {
  const [isActive, setIsActive] = useState(card?.card_status == 'BLOCKED')
  const { errorToast } = handleNotification()
  const { updateIsHidden } = useDataToggleStore()

  const { card_status: cardStatus, uuid, card_type: cardType } = card

  async function onPauseCard() {
    if (!loadingStatus) {
      const toggleRes = await setToggleCard(
        { card_status: cardStatus === 'ACTIVE' ? 'BLOCKED' : 'ACTIVE' },
        uuid
      )
      getCard()

      if (toggleRes.success) {
        updateIsHidden({ state: true, type: cardType })
        setIsActive((prevState) => !prevState)
      } else if (toggleRes.error.message) {
        errorToast(toggleRes.error.message)
      }
    }
  }

  return (
    <div className='mt-5 md:mt-0'>
      <Switch.Group
        as='div'
        className='w-full flex justify-between items-center'
      >
        <Switch.Label className='font-bold text-xl'>
          {PAUSAR_TARJETA}
        </Switch.Label>
        <Switch
          checked={isActive}
          onChange={() => {
            onPauseCard()
          }}
          className={`${
            isActive ? 'bg-green-800' : 'bg-gray-200'
          } relative inline-flex h-8 w-15 items-center rounded-full`}
        >
          <span className='sr-only'>Pausar Tarjeta</span>
          <span
            className={`${
              isActive ? 'translate-x-8' : 'translate-x-1'
            } inline-block h-6 w-6 transform transition ease-in-out duration-200 rounded-full bg-white`}
          />
        </Switch>
      </Switch.Group>
      <p className='mt-4 font-medium text-xs leading-5'>
        💡 Si seleccionás esta opción tu tarjeta pasará a estar inhabilitada de
        forma momentánea hasta que la actives de nuevo.
      </p>
    </div>
  )
}

export default PauseToggle
